import React, { PureComponent } from 'react'
import {
    TextField, PrimaryButton, SpinnerSize, Spinner, Text,
} from '@fluentui/react'
import history from 'helpers/history'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import { ErrorUser } from 'requests/objects/user'
import Status from 'types/status'
import CancelRequestError from 'requests/errors/cancelRequestError'
import NotImplementedError from 'requests/errors/notImplementedError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import { Link } from 'react-router-dom'

/**
 * @augments {React.PureComponent<import('app').AppProps>}
 */
export default class Login extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            /** @type {string} email */
            email: '',
            /** @type {string} Password */
            plainPassword: '',
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {ErrorUser} */
            errorField: new ErrorUser(),
        }
    }

    componentDidMount() {
        const {
            setBreadcrumb, setCommand, setTitle, isAuthenticated,
        } = this.props

        setBreadcrumb([])
        setCommand([])
        setTitle('')

        if (isAuthenticated)
            history.push('/')
    }

    componentWillUnmount() {
        this.usersHandlerLogin?.cancel()
    }

    handleSubmit(ev) {
        ev.preventDefault()
        const { usersHandler, signIn } = this.props
        const { email, plainPassword } = this.state

        this.setState({ status: Status.PENDING }, async () => {
            try {
                this.usersHandlerLogin = usersHandler.login({ email, password: plainPassword })
                const user = await this.usersHandlerLogin.fetch()
                signIn({ accessToken: user.accessToken, refreshToken: user.refreshToken })
                history.push('/')
            } catch (error) {
                this.setState({ status: Status.REJECTED }, () => {
                    switch (error?.constructor) {
                        case CancelRequestError:
                        case UnauthorizedError: break
                        case NotImplementedError:
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                        case InvalidEntityError:
                            this.setState({ errorField: /** @type {InvalidEntityError<ErrorUser>} */(error).errorField })
                            break
                        default:
                            this.setState({ errorField: new ErrorUser() })
                            // eslint-disable-next-line no-console
                            console.error(error)
                            break
                    }
                })
            }
        })
    }

    render() {
        const {
            email, plainPassword, status, errorField,
        } = this.state

        return (
            <form onSubmit={this.handleSubmit.bind(this)}>
                <TextField
                    label="Email"
                    value={email}
                    onChange={ev => this.setState({ email: /** @type {HTMLInputElement} */(ev.target).value })}
                    // iconProps={{ iconName: 'Mail' }}
                    readOnly={status === Status.PENDING}
                    autoComplete="username"
                    errorMessage={errorField.email}
                    required
                />
                <br />
                <TextField
                    label="Mot de passe"
                    type="password"
                    value={plainPassword}
                    onChange={ev => this.setState({ plainPassword: /** @type {HTMLInputElement} */(ev.target).value })}
                    // iconProps={{ iconName: 'PasswordField' }}
                    readOnly={status === Status.PENDING}
                    autoComplete="current-password"
                    errorMessage={errorField.password}
                    required
                    canRevealPassword
                />
                <br />
                <div className="flex-row">
                    <PrimaryButton
                        iconProps={{ iconName: 'FollowUser' }}
                        text="Se connecter"
                        type="submit"
                        disabled={status === Status.PENDING}
                    >
                        {status === Status.PENDING && (
                            <Spinner size={SpinnerSize.small} />
                        )}
                    </PrimaryButton>
                </div>
                <br />
                <Text>
                    <Link to="/motdepasse-oublie">Mot de passe oublié ?</Link>
                </Text>
            </form>
        )
    }
}
